import styles from "../static/query-editor-opener/styles.scss";
import QueryEditorHtml from "../static/query-editor-opener/index.html";
import { ImisMessageType } from "../models/imis.models";
import { MessagesUtility } from "./messages.utility";
import { QueriesUtility } from "./queries.utility";
import * as FormDragDropUtility from "./forms/form-drag-drop.utility";
import { LoaderUtility } from "./loader.utility";
import { DataSourcesUtility } from "./dataSources.utility";
import { TelerikUtility } from "./telerik.utility";

initializeQueryEditorOpener();
initializeFormBuilderButtons();
initializePanelSourcesButtons();

export function initializeQueryEditorOpener() {
    // lazily include style tag when loader added
    styles.use();

    let jBody = jQuery("body");
    let jEditorHtml = jQuery(QueryEditorHtml);
    let jEditorInput = jEditorHtml.find("input");
    let jEditorCloseButton = jEditorHtml.find("a");
    let jEditorErrorContainer = jEditorHtml.find(".query-editor-error-container");
    jBody.append(jEditorHtml);

    // setup keyboard binding for opening of query editor popup
    jBody.on("keydown", function (event) {
        if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() == "s") {
            event.preventDefault();
            jEditorHtml.show();
            jEditorInput.trigger("focus");
        }
    });

    let errorMessageRemoverTimeout;
    let resetPopup = () => {
        jEditorInput.val("");
        jEditorHtml.hide();
    };
    jEditorInput.on("keydown", async (event) => {
        if (event.key === 'Enter') {
            let queryPath = jEditorInput.val().toString();
            if (queryPath.length > 0) {
                try {
                    await QueriesUtility.openQueryEditorByPath(queryPath);
                    resetPopup();
                } catch (error) {
                    let messageId = "queryEditorErrorMessage";
                    MessagesUtility.showMessage(messageId, error, ImisMessageType.ERROR, jEditorErrorContainer);

                    if (errorMessageRemoverTimeout) {
                        clearTimeout(errorMessageRemoverTimeout);
                    }
                    errorMessageRemoverTimeout = setTimeout(() => {
                        MessagesUtility.removeMessage(messageId);
                    }, 5000);
                }
            }
        }

        if (event.key === 'Escape') {
            resetPopup();
        }
    });
    jEditorCloseButton.on("click", () => {
        resetPopup();
    });
}

export function initializeFormBuilderButtons() {
    let jDragAndDropButtonsContainer = jQuery("[id$=DragAndDrop_FormButtons]>.ribbon>div>:nth-child(2)");
    if (jDragAndDropButtonsContainer.length > 0) {
        let jAddRowButton = jQuery("<button type='button' class='TextButton PrimaryButton'>Add Row</button>");
        jAddRowButton.on("click", async function () {
            let numberOfColumnsString = prompt("You are about to add a row. Please enter the number of columns you want to add.", "1");
            let numberOfColumns = parseInt(numberOfColumnsString);
            if (isNaN(numberOfColumns) || numberOfColumns < 1) {
                alert("Please enter a valid number of columns.");
                return;
            }

            try {
                await FormDragDropUtility.addRow(numberOfColumns);
                window.location.reload();
            } catch (error) {
                alert(error);
            }
        });
        jDragAndDropButtonsContainer.append(jAddRowButton);

        let jUpdateRowButton = jQuery("<button type='button' class='TextButton PrimaryButton'>Update Row</button>");
        jUpdateRowButton.on("click", async function () {
            let rowNumberString = prompt("You are about to update a row. Please enter the row number you want to update.", "1");
            let rowNumber = parseInt(rowNumberString);
            if (isNaN(rowNumber) || rowNumber < 1) {
                alert("Please enter a valid row number.");
                return;
            }
            let numberOfColumnsString = prompt(`Please enter the number of columns that should be in this row. This could potentially wipe out data for columns that are deleted.`, "1");
            let numberOfColumns = parseInt(numberOfColumnsString);
            if (isNaN(numberOfColumns) || numberOfColumns < 1) {
                alert("Please enter a valid number of columns.");
                return;
            }

            try {
                await FormDragDropUtility.updateRow(rowNumber, numberOfColumns);
                window.location.reload();
            } catch (error) {
                alert(error);
            }
        });
        jDragAndDropButtonsContainer.append(jUpdateRowButton);

        let jDeleteRowButton = jQuery("<button type='button' class='TextButton PrimaryButton'>Delete Row</button>");
        jDeleteRowButton.on("click", async function () {
            let rowNumberString = prompt("You are about to delete a row. Please enter the row number you want to delete.", "1");
            let rowNumber = parseInt(rowNumberString);
            if (isNaN(rowNumber) || rowNumber < 1) {
                alert("Please enter a valid row number.");
                return;
            }

            try {
                await FormDragDropUtility.deleteRow(rowNumber);
                window.location.reload();
            } catch (error) {
                alert(error);
            }
        });
        jDragAndDropButtonsContainer.append(jDeleteRowButton);
    }
}

export function initializePanelSourcesButtons() {
    let jPanelSourceGrid = jQuery("[id$=_PanelSourceGrid]");
    if (jPanelSourceGrid.length > 0) {
        let jTopRightPanel = jPanelSourceGrid.find("[id$=_TopRightPanel]");
        let jLink = jQuery("<a style='margin-left: 12px;' href='javascript:void(0)' class='sysicon--before sysicon-copy'>Duplicate panel source</a>");
        jLink.on("click", async function() {
            jPanelSourceGrid = jQuery("[id$=_PanelSourceGrid]");
            let loader = LoaderUtility.addLoader({
                loaderText: "Loading...",
            }, jPanelSourceGrid);
            
            try {
                let targetPanelSourceName = prompt("Please enter the name of the panel source you want to duplicate.", "");
                let panelSourceRecordResponse = await DataSourcesUtility.getDataSourceDefinition(targetPanelSourceName, true);
                if (panelSourceRecordResponse == null) {
                    throw `Panel source with name '${targetPanelSourceName}' not found.`;
                }

                let newPanelSourceName = prompt("Please enter the name of the new panel source.", "");
                let newPanelSourceRecordResponse = await DataSourcesUtility.getDataSourceDefinition(newPanelSourceName);
                if (newPanelSourceRecordResponse != null) {
                    throw `Panel source with name '${newPanelSourceName}' already exists.`;
                }

                newPanelSourceRecordResponse = await DataSourcesUtility.duplicateDataSourceDefinition(targetPanelSourceName, newPanelSourceName);
                if (newPanelSourceRecordResponse == null) {
                    throw `Failed to duplicate panel source with name '${targetPanelSourceName}'.`;
                }
                MessagesUtility.showToastMessage({
                    messageId: "duplicatePanelSource",
                    message: `Successfully duplicated panel source with name '${targetPanelSourceName}' to '${newPanelSourceName}'.`,
                    messageType: ImisMessageType.SUCCESS,
                });
                TelerikUtility.refreshDataGridView(jPanelSourceGrid.parent());
            } catch (error) {
                MessagesUtility.showToastMessage({
                    messageId: "duplicatePanelSource",
                    message: error,
                    messageType: ImisMessageType.ERROR,
                });
            } finally {
                LoaderUtility.removeLoader(loader);
            }
        });

        jTopRightPanel.append(jLink);
    }
}
